import Macy from '$c3local/lib/macy.min.js';

export function initReferenceShow() {
    const imageContainer = document.querySelector('.reference-detail-media-list');
    if (!imageContainer) {
        return;
    }
    new Macy({
        container: imageContainer,
        columns: 2,
        margin: 32,
        breakAt: {
            600: {
                margin: 8,
                columns: 1,
            }
        }
    });

    imageContainer.classList.add('reference-detail-media-list--initialized');
}